import React from 'react';
import cx from 'classnames';
import isEqual from 'is-equal';
import _ from 'lodash';
import { Image, Row, Col, OverlayTrigger, Popover, Alert } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import TinyMCE from "react-tinymce";
import { toast } from 'react-toastify';
import BackButton from '../../../components/BackButton'
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import InputField from "src/legacy/components/InputField";
import CollectionWidgetManager from 'src/services/collections.widget.service'
import MessageTemplate from 'src/templates/DefaultComposeMessage.handlebars';
import dateformat from 'dateformat';
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import DeleteEmailTemplateContainer from './DeleteEmailTemplateContainer.jsx';
import ManageContentContainer from './manageContent';
import ResponsiveHelper from 'src/legacy/services/responsive.helper.jsx';
import styles from "./emailTemplateDetailView.module.scss";
//eslint-disable-next-line
import contentStyle from "!file-loader!./DescriptionContentEditor.css";
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';
import SwitchButton from 'src/components/switchButton';
import Toast from 'src/components/toast';
import { NavLink } from 'react-router-dom';
import Truncate from 'src/components/truncate';

import FileUploadService from 'src/services/file.upload.service';
import { guid } from 'src/services/util';
import S3Upload from 'react-s3-uploader/s3upload'
import AuthService from 'src/services/auth.service';

const apiUrl = `${process.env.REACT_APP_API_URL}`; 
const API_BASE_URL = `${apiUrl}/api/2.0`;

const DefaultAssetIcon ='/images/defaultIcons/default_asset.jpg'

class EmailTemplateDetailView extends React.Component {
  constructor(props) {
    super(props);

    let template = this.props.template;
    let collection = _.get(template, 'collection');
    let assets = _.get(template, 'assets');

    if (collection) {
      assets = _.get(collection, 'assets') || [];
    }


    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedTinyMce = this.localizedCommons.tiny_mce;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedEmailTemplates = this.localizatedSettings.templates.email;

    this.state = {
      name: template && template.name || this.localizedEmailTemplates.untitled,
      subject: template && template.subject || '',
      enableDefault: template && template.default || false,
      personal: _.get(template, 'personal') || true,
      initialContent: template && template.content || this.defaultMessage(),
      content: template && template.content || this.defaultMessage(),
      theme: this.props.theme || { primaryColor: "#E51058"},
      errors: {},
      isCreate: false,
      isLoading: false,
      hasMore: this.props.hasMore,
      emailSignature: this.props.profile.emailSignature,
      isEmailTemplate: true,
      addingAsset: false,
      collection: collection,
      sections: _.get(collection, 'sections'),
      collectionIcon: this.getCollectionIcon(collection),
      assets: this.processAssets(assets),
      warning: _.get(template, 'warning'),
      query: "",
      showPlaceholderPopover: false, 
      showWidgetPopover: false
    }

    this.widgetManager = new CollectionWidgetManager();

    this.onResetClick = this.onResetClick.bind(this);
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleContentChange = this._handleContentChange.bind(this);
    this._handleKeyup = this._handleKeyup.bind(this);
    this._handleCreateTemplateClick = this._handleCreateTemplateClick.bind(this);
    this.handleAddAssetFinish = this.handleAddAssetFinish.bind(this);
    this.handleFileInput = this.handleFileInput.bind(this);
    

    this.populateContentSelection = this.populateContentSelection.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);
    this.handleFileUploadFinish = this.handleFileUploadFinish.bind(this);
  }


  renderLoadingMessages() {
    return (
      <div className={styles.loadingEmail }>
      <p>{`${this.localizedEmailTemplates.uploadingMessage}...`}</p>
      </div>
    );
  }

  _handleFieldChange(field, e) {
    let value = e.target.value;
    this.setState({
      [field]: value
    });
  }

  onToggleChange(field, value) {
    this.setState({
      [field]: value
    })
  }

  _handleContentChange(e) {
    this.setState({
      content: e.target.getContent()
    })
  }

  _handleCreateTemplateClick() {
    this.props.navigate("/settings/email-template/new");
    this.setState({
      isCreate: true,
      name: this.localizedEmailTemplates.untitled,
      assets: null
    });
  }

  handleAddAssetFinish(collection, assets) {
    this.setState({
      addingAsset: false,
      assets: this.processAssets(assets),
      collection: collection,
      sections: _.get(collection, 'sections'),
      collectionIcon: this.getCollectionIcon(collection)
    }, () => {
      this.composeEditor.execCommand('pfWidgetUpdate', false);
    });
  }

  _handleKeyup(e) {
    if (this.composeEditor) {
      var message = this.composeEditor.getContent();
      this.setState({
        content: message
      })
    }
  }

  onResetClick() {
    this.props.showSettingsSideMenu();
    this.props.navigate("/settings/email-template");
  }

  _handleSaveClick() {
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    this.props.createEmailTemplate(this._prepareTemplateDetails()).then((response) => {
      if (!this.props.creating && this.props.error) {
        toast(
          <Toast.Failure
            message={this.props.error.errors[0].message}
          />, {
          autoClose: 3000,
        })
      }
      else {
        this.setState({
          isCreate: false,
          selectedTemplate: response.payload,
        });
        this.props.navigate(`/settings/email-template/${response.payload.id}`);
      }
    });
  }

  _handleUpdateClick() {

    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    this.props.updateEmailTemplate(this.props.template.id, this._prepareTemplateDetails()).then((response) => {
      if (!this.props.updating && this.props.error) {
        toast(
          <Toast.Failure
            message={this.props.error.errors[0].message}
          />, {
          autoClose: 3000,
        })

        this.props.fetchEmailTemplate(response.payload.id);
      }
    });
  }

  _prepareTemplateDetails() {

    let emailTemplate = {
      name: this.state.name,
      subject: this.state.subject,
      content: this.state.content,
      isDefault: this.state.enableDefault,
      personal: this.state.personal,
      collection: null,
      assets: []
    }

    if (this.state.collection) {
      emailTemplate.collection = this.state.collection.id;
      emailTemplate.assets = [];
    } else if (_.size(this.state.assets) > 0) {
      emailTemplate.collection = null;
      emailTemplate.assets = this.state.assets.map((item) => {
        return _.get(item, 'asset.id');
      });
    }

    return emailTemplate;
  }

  _handleDeleteClick() {
    this.setState({
      isDeleteView: true
    });
  }

  defaultMessage() {
    return MessageTemplate();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isCreate && (!isEqual(this.props.template, nextProps.template))) {

      let collection = _.get(nextProps.template, 'collection');
      let assets = _.get(nextProps.template, 'assets');

      if (collection) {
        assets = _.get(collection, 'assets') || [];
      }

      this.setState({
        name: _.get(nextProps, 'template.name') || "",
        subject: _.get(nextProps, 'template.subject') || "",
        enableDefault: _.get(nextProps, 'template.default') || false,
        personal: _.get(nextProps, 'template.personal') || false,
        initialContent: _.get(nextProps, 'template.content') || this.defaultMessage(),
        content: _.get(nextProps, 'template.content') || this.defaultMessage(),
        selectedTemplate: nextProps.template,
        collection: collection,
        collectionIcon: this.getCollectionIcon(collection),
        sections: _.get(collection, 'sections'),
        assets: this.processAssets(assets),
        warning: _.get(nextProps, 'template.warning')
      }, () => {
        this.composeEditor.execCommand('pfWidgetUpdate', false);
      })
    }

    if (!this.state.isCreate && _.get(nextProps,"params.id") != "new" && _.size(nextProps, "emailTemplates", []) > 0) {
      const idFromPath = _.get(nextProps, "params.id");
      const isIdExists = _.find(nextProps.emailTemplates, { id: idFromPath });
      const firstTemplate = nextProps.emailTemplates[0];
      if (!isIdExists && firstTemplate && firstTemplate.id) {
        this.props.navigate(`/settings/email-template/${firstTemplate.id}`);
      }
    }

    if (nextProps.params && (nextProps.params.id != this.props.params.id)) {
      this.setState({
        isCreate: false
      });

      window.tinyMCE.remove();
      this.props.fetchEmailTemplate(nextProps.params.id);
    }

    if (nextProps.params.id === "new" && !this.state.isCreate) {
      this.setState({
        isCreate: true,
        name: this.localizedEmailTemplates.untitled,
        assets: null,
        personal: true
      });
    }

    if (this.props.hasMore != nextProps.hasMore) {
      this.setState({
        hasMore: nextProps.hasMore
      });
    }
  }

  componentDidMount() {
    this.props.fetchEmailTemplates(this.state.query, 0);
    this.props.hideSettingsSideMenu();
    if (this.props.params.id && this.props.params.id != "new") {
      this.props.fetchEmailTemplate(this.props.params.id);
    }
  }

  componentWillUnmount() {
    this.props.showSettingsSideMenu();
    window.tinyMCE.remove();
  }

  handleInsertWidgetClick(widgetID) {
    var widget = this.widgetManager.widget(widgetID);
  
    if (widget) {
      var template = widget.render(null, this.state);
      this.composeEditor.execCommand('mceInsertContent', false, template.outerHTML);
      this.composeEditor.execCommand('pfWidgetUpdate', false, template);
    }
  
    this.setState({ showWidgetPopover: false });
  }

  handleInsertPlaceholderClick(variableId) {
    var variable = this.widgetManager.variable(variableId);
  
    if (variable) {
      this.composeEditor.plugins.variable.addVariable(variable.id);
    }
  
    this.setState({ showPlaceholderPopover: false });
  }

  _validateForm() {
    var errors = {};
    if (!this.state.name || this.state.name.trim() == '') {
      errors['name'] = this.localizedEmailTemplates.form.valid_name;
    }
    if (this.state.content == '' || this.state.content == null) {
      errors['content'] = this.localizedEmailTemplates.form.valid_content;
    }
    return errors;
  }

  processAssets(assets) {
    if (!assets) {
      return [];
    }

    assets.map((item, index) => {
      if (item.entityType == 'asset' && !item.settings.share) {
        assets.splice(index, 1);
      }
    });

    return assets.map(item => {
      if (item.type == 'asset') {
        var icon = item.asset.icon || {
          thumbnail: DefaultAssetIcon
        };

        return Object.assign({}, item, {
          ...item,
          asset: {
            ...item.asset,
            icon
          }
        })
      } else if (item.entityType == 'asset') {
        var icon = item.icon || {
          thumbnail: DefaultAssetIcon
        };

        return Object.assign({}, item, {
          ...item,
          type: "asset",
          asset: {
            ...item,
            icon
          }
        })
      }

      return item;
    });
  }

  populateContentSelection() {
    const collection = _.get(this.state, 'collection');
    const assets = _.get(this.state, 'assets') || [];

    if (collection) {
      this.props.invalidateCollectionsSelection();
      this.props.selectCollection(collection);
    } else {
      this.props.invalidateCollectionsSelection();
      this.props.invalidateAssetSelection();
      _.size(this.state.assets) !== 0 && this.state.assets.forEach(item => {
        this.props.selectAsset(item.asset);
      });
    }
  }

  getCollectionIcon(collection) {
    if(!collection){
      return null;
    }

    var background = _.get(collection, 'banner.background');
    if (background && background.type == "image") {
      return background.full;
    } else if (background && background.type == "video") {
      return background.thumbnail;
    }

    return DefaultAssetIcon;
  }
  
  _handleClearClick(){
    this.setState({
      query : ""
    }, () => {
      this.props.invalidateEmailTemplates();
      this.props.fetchEmailTemplates("", 0);
    })
  }

  handleFileUploadProgress = (progress, textState, file) => {
    this.setState({isLoading :true});
  };

  handleFileUploadError = (err) => {
    this.setState({isLoading : false})
  };
  

  handleFileUploadFinish = (info, file) => {
    const img = document.createElement("img");

    let fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (e) => {

      const src = e.target.result;

      img.onload = () => {
        let width = img.width;
        let height = img.height;
        const aspectRatio = height / width;
        var resizedWidth = width * aspectRatio;
        resizedWidth = Math.min(600, resizedWidth);

        const dimensions = { width, height };

        this.props.uploadMedia(info, file, dimensions).then((res) => {
          this.setState(
            {
              imageUrl: res.payload.image.url,
            },
            () => {
              const editor = this.composeEditor;
              if (editor) {
                editor.insertContent(
                  `<img src="${this.state.imageUrl}" style="display: inline-block; width: ${resizedWidth}px;" />`,
                  true
                );
              }
              this.setState({ isLoading: false });
            }
          );
        });
      };
      img.onerror =() => {
        this.setState({isLoading : false});
      }

      img.src = src;
    };
  };


  uploadFiles(file) {
    this.setState({isLoading :true});
    file.id = guid();
    const fileName = _.get(file, "name", "Untitled");
      
    var s3Uploader = new S3Upload({
      signingUrl: "/file_upload/initiate",
      signingUrlMethod: "POST",
      signingUrlHeaders: {
        Authorization: `Bearer ${AuthService.getAccessToken()}`,
      },
      server: API_BASE_URL,
      scrubFilename: (filename) => {
        var name = filename.replace(/[^\w\d_\-.\s]+/ig, "");
        return encodeURIComponent(name);
      },
      
      signingUrlQueryParams: { originalName: encodeURIComponent(fileName) },
      contentDisposition: "auto",
      uploadRequestHeaders: {},
      onFinishS3Put: this.handleFileUploadFinish,
      onProgress: this.handleFileUploadProgress,
      onError: this.handleFileUploadError,
      files: [file],
    });

    FileUploadService.trackUpload(s3Uploader);
  }
  handleFileInput() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept =
      "image/jpg, image/jpeg, image/png, image/gif";

    input.onchange = () => {
      const file = input.files[0];
      {
        this.uploadFiles(file);
      }
    };
    input.click();
  }

  render() {
    let validVariables = this.widgetManager.variables().map((item) => {
      return item.id;
    });

    var isMobile = ResponsiveHelper.isMobile();
    var isTablet = ResponsiveHelper.isTablet();
    var isTabletls = ResponsiveHelper.isTabletls();

    const hasContent = !(_.size(this.state.assets) == 0 && _.get(this.state, 'collection') == null);

    return (
      <Row className={styles.content}>
        <Col md={5} className={cx(styles.left)}>
          <div className={styles.innerContent}>
            {!this.props.showSettingsMenu && (
              <BackButton
                className={styles.back}
                title={this.localizedCommonActions.back}
                onClick={() => this._handleBackClick()}
              ></BackButton>
            )}

            <h2
              className={cx(
                styles.title,
                !this.props.showSettingsMenu && styles.innerPageTitle,
              )}
            >
              {this.localizedEmailTemplates.title}
            </h2>
            {!this.props.showSettingsMenu && (
              <div
                onClick={() => this._handleCreateTemplateClick()}
                className={styles.createTemplate}
              >
                <div
                  className={cx(styles.heading, {
                    [styles.disabled]: this.state.isCreate,
                    [styles.default]: !this.state.isCreate,
                  })}
                >
                  <i className="paperflite-add" aria-hidden="true" />
                  <div className={styles.createTemplateText}>
                    {this.localizedEmailTemplates.create_new_template}
                  </div>
                </div>
              </div>
            )}

            <div
              className={cx(
                styles.section,
                !this.props.showSettingsSideMenu && styles.innerPageSection,
              )}
            >
              <div className={cx(styles.searchInputField, styles.searchField)}>
                <label>
                  <i className="paperflite-search"></i>
                  <input
                    type="text"
                    value={this.state.query}
                    placeholder={
                      this.localizedEmailTemplates.placeholder.template
                    }
                    onChange={this._handleSearch.bind(this)}
                  />
                </label>
                {this.state.query.length > 0 && (
                  <i
                    className={cx("paperflite-close", styles.closeIcon)}
                    onClick={() => this._handleClearClick()}
                  ></i>
                )}
              </div>
            </div>

            {!this.props.loading &&
              (this.props.emailTemplates.length > 0 || this.state.isCreate) && (
                <div className={styles.header}>
                  <Col sm={this.props.showSettingsMenu ? 5 : 7}>
                    <div>
                      {this.localizedEmailTemplates.headers.template_name}
                    </div>
                  </Col>
                  <Col sm={this.props.showSettingsMenu ? 3 : 5}>
                    <div>{this.localizedEmailTemplates.headers.owner}</div>
                  </Col>
                  {this.props.showSettingsMenu && (
                    <Col sm={2}>
                      <div>
                        {this.localizedEmailTemplates.headers.last_updated}
                      </div>
                    </Col>
                  )}
                  {this.props.showSettingsMenu && (
                    <Col sm={2}>
                      <div>
                        {this.localizedEmailTemplates.headers.mark_as_public}c
                      </div>
                    </Col>
                  )}
                </div>
              )}

            {!this.props.loading && (
              <div className={styles.list}>
                {this.state.isCreate && this._renderCreateNewTemplate()}
                {this.props.emailTemplates.length > 0 &&
                  this._renderEmailTemplates()}
              </div>
            )}

            {this.props.loading && this.props.emailTemplates.length === 0 && (
              <div className={styles.loading}>
                {this.localizedCommonLoading.loading}...
              </div>
            )}
          </div>
        </Col>

        {!this.props.fetching && (
          <Col md={7} className={styles.right}>
            <div className={styles.innerContent}>
              {!this.props.isCreate &&
                this.props.template &&
                this.props.template.createdBy.id == this.props.profile.id && (
                  <div
                    className={cx(styles.deleteTemplate)}
                    onClick={this._handleDeleteClick}
                  >
                    <i
                      className={cx("paperflite-delete", styles.controlIcons)}
                    ></i>
                    <span className={styles.deleteIcon}>
                      {this.localizedCommonActions.delete}
                    </span>
                  </div>
                )}

              <div
                className={cx(styles.addAsset)}
                onClick={() => {
                  this.populateContentSelection();
                  this.setState({
                    addingAsset: true,
                  });
                }}
              >
                <span
                  className={cx(
                    styles.addIcon,
                    hasContent ? "paperflite-edit" : "paperflite-add",
                    styles.controlIcons,
                  )}
                ></span>
                <span className={styles.deleteIcon}>
                  {hasContent
                    ? this.localizedEmailTemplates.actions.manage_content
                    : this.localizedEmailTemplates.actions.add_asset}
                </span>
              </div>

              <Row className={cx(styles.section, styles.sectionRow)}>
                <Col sm={12}>
                  <InputField
                    title={`${this.localizedEmailTemplates.form.template_name}`}
                    type="text"
                    className={styles.inputField}
                    placeholder={
                      this.localizedEmailTemplates.form.template_placeholder
                    }
                    value={this.state.name}
                    onChange={this._handleFieldChange.bind(this, "name")}
                    errorMessage={this.state.errors["name"]}
                  />
                </Col>
                <Col sm={6} className={cx(styles.top, styles.switch)}>
                  <span>{this.localizedEmailTemplates.form.set_as_public}</span>
                  <div className={styles.switchButton}>
                    <SwitchButton
                      id="enablePublic"
                      handleCheck={() => {
                        this.setState({
                          personal: !this.state.personal,
                        });
                      }}
                      checked={!this.state.personal}
                    />
                  </div>
                </Col>
                <Col sm={6} className={cx(styles.top, styles.switch)}>
                  <span>
                    {this.localizedEmailTemplates.form.set_as_default}
                  </span>
                  <div className={styles.switchButton}>
                    <SwitchButton
                      id="enableDefault"
                      handleCheck={() =>
                        this.onToggleChange(
                          "enableDefault",
                          !this.state.enableDefault,
                        )
                      }
                      checked={this.state.enableDefault}
                    />
                  </div>
                </Col>
                <Col xl={12} sm={12} className={styles.top}>
                  <InputField
                    className={styles.inputField}
                    title={`${this.localizedEmailTemplates.form.email_subject}`}
                    type="text"
                    value={this.state.subject}
                    onChange={this._handleFieldChange.bind(this, "subject")}
                  />
                </Col>
                <div className={styles.loadingEmailContainer}>
                  {this.state.isLoading && this.renderLoadingMessages()}
                </div>
                <Col xl={12} sm={12} className={styles.welcomeMessage}>
                  <label className={styles.msgDescription}>
                    {this.localizedEmailTemplates.form.email_content}:
                  </label>

                  <div className={styles.widgetActions}>
                    {this._renderPlaceholderPopover()}
                    {this._renderWidgetPopover()}
                  </div>
                  <TinyMCE
                    content={this.state.initialContent}
                    config={{
                      branding: false,
                      statusbar: false,
                      contextmenu: false,
                      plugins:
                        "noneditable, variable, widget,  autolink, link, image, code, textcolor, lists, paste",
                      menubar: false,
                      toolbar:
                        "bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor |  addImageButton | link | code",
                      insert_toolbar: "",
                      fontsize_formats:
                        "5pt 5.5pt 6.5pt 7.5pt 8pt 9pt 10pt 10.5pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt",
                      anchor_top: false,
                      anchor_bottom: false,
                      resize: true,
                      height: 350,
                      content_css: [
                        "https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
                        contentStyle,
                      ],
                      font_formats:
                        "Montserrat=montserrat,Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbat",
                      extended_valid_elements: "p[style|class]",
                      default_link_target: "_blank",
                      browser_spellcheck: true,
                      paste_convert_word_fake_lists: false,
                      paste_retain_style_properties:
                        "color font-size border border-collapse border-width border-color border-style background background-color",
                      paste_webkit_styles:
                        "color font-size border border-collapse border-width border-color border-style background background-color",
                      noneditable_editable_class: "mceEditable",
                      remove_trailing_brs: false,
                      convert_urls: false,
                      relative_urls: false,
                      remove_script_host: false,
                      variable_mapper: (id) => {
                        let variable = this.widgetManager
                          .variables()
                          .find((item) => {
                            return item.id == id;
                          });

                        if (variable) {
                          return variable.name;
                        }
                      },
                      variable_valid: validVariables,
                      widget_mapper: (id, existingNode) => {
                        var widget = this.widgetManager.widget(id);
                        if (widget) {
                          widget.render(existingNode, this.state);
                        }
                      },
                      setup: (editor) => {
                        this.composeEditor = editor;
                        editor.on("SetContent", function (e) {
                          editor.execCommand("pfWidgetUpdate", false);
                        });

                        editor.ui.registry.addButton("collectionWidget", {
                          icon: "image",
                          tooltip: "Insert Collection as a card",
                          onclick: () => {
                            var widget =
                              this.widgetManager.widget("collection.card");
                            if (widget) {
                              var template = widget.render(null, this.state);
                              editor.execCommand(
                                "mceInsertContent",
                                false,
                                template.outerHTML,
                              );
                              editor.execCommand(
                                "pfWidgetUpdate",
                                false,
                                template,
                              );
                            }
                          },
                        });

                        editor.ui.registry.addButton("assetsWidget", {
                          icon: "image",
                          tooltip: "Insert assets as a table",
                          onclick: () => {
                            var widget =
                              this.widgetManager.widget("assets.grid");
                            if (widget) {
                              var template = widget.render(null, this.state);
                              editor.execCommand(
                                "mceInsertContent",
                                false,
                                template.outerHTML,
                              );
                              editor.execCommand(
                                "pfWidgetUpdate",
                                false,
                                template,
                              );
                            }
                          },
                        });

                        editor.ui.registry.addButton("addImageButton", {
                          icon: "image",
                          onAction: () => this.handleFileInput(),
                        });

                        editor.on("ExecCommand", function (e) {
                          var selection =
                            window.tinyMCE.activeEditor.selection.getContent();
                          var el = document.createElement("html");
                          el.innerHTML =
                            "<head></head><body>" + selection + "</body>";
                          var datapoints = Array.from(
                            el.getElementsByClassName("variable"),
                          );
                          if (datapoints.length > 0) {
                            var styleToggle = function (key, value) {
                              var criteria = datapoints
                                .map(function (datapoint) {
                                  return datapoint.style[key] == value;
                                })
                                .reduce(function (a, b) {
                                  return a && b;
                                });
                              if (criteria) {
                                datapoints.forEach(function (datapoint) {
                                  datapoint.style[key] = "";
                                  datapoint.contentEditable = false;
                                });
                              } else {
                                datapoints.forEach(function (datapoint) {
                                  datapoint.style[key] = value;
                                  datapoint.contentEditable = false;
                                });
                              }
                            };
                            switch (e.command) {
                              case "mceToggleFormat":
                                switch (e.value) {
                                  case "bold":
                                    styleToggle("font-weight", "bold");
                                    break;
                                  case "italic":
                                    styleToggle("font-style", "italic");
                                    break;
                                  case "strikethrough":
                                    styleToggle(
                                      "text-decoration",
                                      "line-through",
                                    );
                                    break;
                                  case "underline":
                                    styleToggle("text-decoration", "underline");
                                }
                                window.tinyMCE.activeEditor.selection.setContent(
                                  el.children[1].innerHTML,
                                );
                                break;
                              case "mceApplyTextcolor":
                                styleToggle("color", e.value);
                                window.tinyMCE.activeEditor.selection.setContent(
                                  el.children[1].innerHTML,
                                );
                                break;
                              case "FontName":
                                styleToggle("font-family", e.value);
                                window.tinyMCE.activeEditor.selection.setContent(
                                  el.children[1].innerHTML,
                                );
                                break;
                              case "FontSize":
                                styleToggle("font-size", e.value);
                                window.tinyMCE.activeEditor.selection.setContent(
                                  el.children[1].innerHTML,
                                );
                                break;
                              case "RemoveFormat":
                                datapoints.forEach(function (datapoint) {
                                  [
                                    "font-weight",
                                    "font-style",
                                    "text-decoration",
                                    "text-decoration",
                                    "color",
                                    "font-family",
                                    "font-size",
                                  ].forEach(function (key) {
                                    datapoint.style[key] = "";
                                  });
                                  datapoint.contentEditable = false;
                                });
                                window.tinyMCE.activeEditor.selection.setContent(
                                  el.children[1].innerHTML,
                                );
                                break;
                            }
                          }
                        });
                      },
                    }}
                    onChange={this._handleContentChange}
                    onKeyup={this._handleKeyup}
                  />
                  {this.state.errors["content"] && (
                    <div className={styles.contentError}>
                      {this.localizedEmailTemplates.form.valid_content}
                    </div>
                  )}
                </Col>
              </Row>
              <div className={styles.buttonTray}>
                <Button
                  variant="primary"
                  text={this._renderCreateOrUpdateText()}
                  className={cx(styles.confirm, {
                    [styles.updating]:
                      this.props.creating || this.props.updating,
                  })}
                  onClick={
                    this.state.isCreate
                      ? this.props.creating
                        ? ""
                        : this._handleSaveClick
                      : this.props.updating
                        ? ""
                        : this._handleUpdateClick
                  }
                  icon="paperflite-tick"
                ></Button>
                <Button
                  variant="secondary"
                  text={this.localizedCommonActions.cancel}
                  className={styles.cancel}
                  onClick={this.onResetClick}
                ></Button>
              </div>
            </div>

            {this.renderWarning()}
          </Col>
        )}
        <div className={styles.addAsset}>
          {/* <SlidePaneView width="30vw" show={this.state.addingAsset}> */}
          {this.state.addingAsset && (
            <ManageContentContainer
              onFinish={this.handleAddAssetFinish}
              onCancel={() => {
                this.setState({
                  addingAsset: false,
                });
              }}
              source="Settings"
            />
          )}
          {/* </SlidePaneView> */}
        </div>

        <SlidePaneView width="30vw" show={this.state.isDeleteView}>
          <DeleteEmailTemplateContainer
            template={this.props.template}
            onDeletion={() => {
              this.setState({
                isDeleteView: false,
              });
            }}
            onCancel={() => {
              this.setState({
                isDeleteView: false,
              });
            }}
          />
        </SlidePaneView>
      </Row>
    );
  }

  _renderCreateOrUpdateText() {
    if (this.state.isCreate) {
      return this.props.creating ? `${this.localizedCommonActions.creating}...` : this.localizedCommonActions.create
    } else {
      return this.props.updating ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save
    }
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedEmailTemplates.loading_template}...`}
        visible={true}
      />
    );
  }

  _handleSearch(e) {
    this.props.invalidateEmailTemplates();
    this.setState({
      query: e.target.value,
      selectedTemplate: null
    })
    this.props.fetchEmailTemplates(e.target.value, 0);
  }

  _renderEmailTemplates() {
    var rows = Array();
    this.props.emailTemplates.forEach((emailTemplate, index) => {
      var id = emailTemplate.id;
      let activated = this.enabledPersonal(emailTemplate.personal);

      rows.push(
        <NavLink to={`/settings/email-template/${emailTemplate.id}`} className={styles.link} key={emailTemplate.id}>
          <Row className={cx(styles.templateRow,
            (this.state.selectedTemplate && emailTemplate.id === this.state.selectedTemplate.id) && styles.seletedRow)
          } key={id}>
            <Col sm={12}>
              <div className={styles.usertemplates} onClick={() => { this._handleTemplateClick(emailTemplate) }}>
                <Col sm={this.props.showSettingsMenu ? 5 : 7} className={styles.noPadding}>
                  <Truncate lines={1}>{emailTemplate.name}
                    {emailTemplate.default && <span className={styles.default}> ({this.localizedEmailTemplates.default})</span>}
                  </Truncate>
                </Col>
                <Col sm={this.props.showSettingsMenu ? 3 : 5} className={styles.name}>
                  <Truncate lines={1}> {this._renderName(emailTemplate.createdBy)}</Truncate>
                </Col>
                {this.props.showSettingsMenu &&
                  <Col sm={2}>
                    <div>{dateformat(emailTemplate.modifiedDate, 'dd mmm yyyy')}</div>
                  </Col>
                }
              </div>
              {this.props.showSettingsMenu &&
                <Col sm={2}>
                  <div className={styles.switchButton}>
                    <SwitchButton 
                      id={`makePublic-${id}`}
                      handleCheck={this.onToggleChange.bind(this, id)}
                      checked={activated} />
                  </div>
                </Col>
              }
            </Col>
          </Row>
        </NavLink>
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.state.hasMore}
        loadMore={(page) => { this.loadMoreItems(page) }}
        useWindow={false}
        threshold={100}
      >
        {rows}
      </InfiniteScroll>
    );
  }

  enabledPersonal(personal) {
    let enablePersonal = personal ? false : true;
    return enablePersonal;
  }

  _renderName(owner) {
    if (owner) {
      return `${owner.firstName || ''} ${owner.lastName || ''}`
    }
  }

  _handleBackClick() {
    this.props.showSettingsSideMenu();
    this.props.navigate("/settings/email-template");
  }

  _handleTemplateClick(emailTemplate) {
    this.setState({
      selectedTemplate: emailTemplate,
      isCreate: false
    });
    this.props.hideSettingsSideMenu();
    this.props.fetchEmailTemplate(emailTemplate.id);
    
    this.setState({
      errors: {}
    });
  }

  _renderCreateNewTemplate() {
    return (
      <Row className={cx(styles.templateRow, styles.seletedRow)}>
        <Col sm={12}>
          <div className={styles.usertemplates}>
            <Col sm={this.props.showSettingsMenu ? 5 : 7} className={styles.noPadding}>
              <Truncate lines={1}> {this.localizedEmailTemplates.untitled} </Truncate>
            </Col>
            <Col sm={this.props.showSettingsMenu ? 3 : 5} className={styles.name}>
              <Truncate lines={1}> {this._renderName(this.props.profile)} </Truncate>
            </Col>
          </div>
        </Col>
      </Row>
    );
  }


  _renderWidgetPopover() {
    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" className={styles.widgetPopover}>
        <div className={styles.widget} onClick={this.handleInsertWidgetClick.bind(this, 'assets.grid')}>
          <div align='middle' className={cx(styles.icon, styles.assetTable)}></div>
          <div>
            <div>{this.localizedTinyMce.insert_widget.asset_table.title}</div>
            <p>{this.localizedTinyMce.insert_widget.asset_table.description}</p>
          </div>
        </div>
        <div className={styles.widget} onClick={this.handleInsertWidgetClick.bind(this, 'collection.cta')}>
          <div align='middle' className={cx(styles.icon, styles.viewCollection)}></div>
          <div>
            <div>{this.localizedTinyMce.insert_widget.view_collection_button.title}</div>
            <p>{this.localizedTinyMce.insert_widget.view_collection_button.description}</p>
          </div>
        </div>
        <div className={styles.widget} onClick={this.handleInsertWidgetClick.bind(this, 'collection.link')}>
          <div align='middle' className={cx(styles.icon, styles.textLink)}></div>
          <div>
            <div>{this.localizedTinyMce.insert_widget.link.title}</div>
            <p>{this.localizedTinyMce.insert_widget.link.description}.</p>
          </div>
        </div>
        {this.props.profile.emailSignature &&
          <div className={styles.widget} onClick={this.handleInsertWidgetClick.bind(this, 'signature.description')}>
            <div align='middle' className={cx(styles.icon, styles.emailSignature)}></div>
            <div>
              <div>{this.localizedTinyMce.insert_widget.signature.title}</div>
              <p>{this.localizedTinyMce.insert_widget.signature.description}</p>
            </div>
          </div>
        }
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" rootClose placement="bottom"
        overlay={popoverClickRootClose}  show={this.state.showWidgetPopover}
        onToggle={(show) => this.setState({ showWidgetPopover: show })}>
        <button className={styles.widgetButton} onClick={() => this.setState({ showWidgetPopover: true })}>{this.localizedEmailTemplates.form.insert_widget_template}</button>
      </OverlayTrigger>
    );
  }

  _renderPlaceholderPopover() {
    var placeholderMenu = (
      <Popover id="placeholder-popover-trigger-click-root-close" className={styles.placeholderPopover}>
        <ul>
          <li onClick={this.handleInsertPlaceholderClick.bind(this, 'contact.firstname')}>{this.localizedTinyMce.insert_placeholder.first_name}</li>
          <li onClick={this.handleInsertPlaceholderClick.bind(this, 'contact.lastname')}>{this.localizedTinyMce.insert_placeholder.last_name}</li>
          <li onClick={this.handleInsertPlaceholderClick.bind(this, 'contact.company')}>{this.localizedTinyMce.insert_placeholder.company}</li>
          <li onClick={this.handleInsertPlaceholderClick.bind(this, 'signature.description')}>{this.localizedTinyMce.insert_placeholder.signature}</li>
        </ul>
      </Popover>
    );
  
    return (
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom"
        overlay={placeholderMenu}
        show={this.state.showPlaceholderPopover} 
        onToggle={(show) => this.setState({ showPlaceholderPopover: show })} 
      >
        <button
          className={styles.widgetButton}
          onClick={() => this.setState({ showPlaceholderPopover: true })} // Show on button click
        >
          {this.localizedEmailTemplates.form.insert_placeholder}
        </button>
      </OverlayTrigger>
    );
  }
  loadMoreItems(page) {
    if (this.props.loadMore) {
      this.props.loadMore(page);
    }
    this.props.fetchEmailTemplates(this.state.query, page);
  }

  renderWarning() {
    const warning = this.state.warning;
    if (!warning) {
      return false;
    }

    let icon = '';
    let title = '';
    let message = '';
    let show = false;

    if(warning.deletion){
      icon = `fa fa-trash`;
      title = this.localizedEmailTemplates.warning.deletion.title;
      message = this.localizedEmailTemplates.warning.deletion.message;
      show = true;
    }else if(warning.permission || warning.internal){
      icon = `fa fa-lock`;
      title = this.localizedEmailTemplates.warning.internal.title;
      message = this.localizedEmailTemplates.warning.internal.message;;
      show = true;
    }

    if(!show){
      return false;
    }

    return (
      <Alert bsStyle="danger" className={cx(styles.accessError)}>
        <button className={styles.dismissButton} onClick={() => {
            this.setState({
              warning: null
            });
          }}>
          <span className='lnr lnr-cross'></span>
        </button>
        <i className={cx(styles.icon, icon)} />
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{message}</div>
        </div>
      </Alert>
    );
  }
}

export default EmailTemplateDetailView;

